module.exports = __webpack_public_path__ + "static/media/12-mobile.f992380f.jpg";